import React from 'react';

/** components */
import LabelWithTooltip from './LabelWithTooltip';

/** helpers */
import { validateInputField } from '../../helpers/validation';
import { useForm } from '../../hooks/useForm';

const SingleSelect = ({
  data,
  setData,
  dataError,
  setDataError,
  field,
  toggleFieldModal,
  isModalOpen,
  initializeSectionError,
  maskInputEl,
  feature,
  fieldClassName,
}) => {
  const { getPropertyFields } = useForm();
  const filteredOptions = field.options.filter((option) => {
    if (field.linked) return option.displayForValue === data[field.linked];
    return true;
  });
  if (filteredOptions.length === 0 && data[field.name] !== '') {
    setData({ ...data, [field.name]: '' });
  }

  const handleChange = (e, name, field) => {
    initializeSectionError();
    validateInputField(e.target.value, name, field, setDataError);

    let updateValues = { [name]: e.target.value };
    let updatedValues = getPropertyFields(feature, data, updateValues, field?.name, true);

    let values = updatedValues.isUpdatedValue ? updatedValues.newValues : updateValues;

    setData({ ...data, ...values });
    maskInputEl?.current?.setInputValue('');
  };

  return (
    <>
      <div key={field.name} className={fieldClassName}>
        <div className="form-field">
          <LabelWithTooltip
            field={field}
            toggleFieldModal={toggleFieldModal}
            isModalOpen={isModalOpen}
          />
          <select
            onChange={(e) => handleChange(e, field.name, field)}
            value={data[field.name]}
            name={field.name}
            spellCheck={false}
          >
            <option value="">Select an option</option>
            {filteredOptions.map((option, index) => (
              <option value={option.value} key={'option' + option.value + index}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        {dataError[field.name] && <p className="error-text">{dataError[field.name]}</p>}
      </div>
    </>
  );
};

export default SingleSelect;
